import React from "react";
import { PawPrint, Instagram, MapPin, Phone } from "lucide-react";
import { CLINIC, telLink } from "../lib/contact";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#2D3A30] text-[#E3F0E6] pt-16 pb-10"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-2 mb-4">
            <div className="w-10 h-10 rounded-2xl bg-[#F28C8C] flex items-center justify-center">
              <PawPrint className="w-5 h-5 text-white" strokeWidth={2.5} />
            </div>
            <div className="leading-tight">
              <div className="font-heading font-semibold text-white text-lg">
                Royal Pets
              </div>
              <div className="text-[10px] text-[#A6BFAB] tracking-widest uppercase font-semibold">
                Veterinaria
              </div>
            </div>
          </div>
          <p className="text-sm text-[#A6BFAB] max-w-xs leading-relaxed">
            Atención médica veterinaria con cariño y disponibilidad 24/7 en La
            Serena.
          </p>
        </div>

        <div className="space-y-3">
          <div className="text-[10px] tracking-widest uppercase font-bold text-[#A6BFAB]">
            Contacto
          </div>
          <a
            href={telLink}
            data-testid="footer-phone"
            className="flex items-start gap-3 hover:text-white transition-colors"
          >
            <Phone className="w-4 h-4 mt-1 text-[#F28C8C]" />
            <span className="text-sm">{CLINIC.phoneDisplay}</span>
          </a>
          <div className="flex items-start gap-3">
            <MapPin className="w-4 h-4 mt-1 text-[#F28C8C]" />
            <span className="text-sm">{CLINIC.address}</span>
          </div>
          <a
            href={CLINIC.instagramUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-instagram"
            className="flex items-start gap-3 hover:text-white transition-colors"
          >
            <Instagram className="w-4 h-4 mt-1 text-[#F28C8C]" />
            <span className="text-sm">{CLINIC.instagramHandle}</span>
          </a>
        </div>

        <div className="space-y-3">
          <div className="text-[10px] tracking-widest uppercase font-bold text-[#A6BFAB]">
            Horario
          </div>
          <div className="bg-white/5 rounded-2xl p-5 border border-white/10">
            <div className="font-heading text-3xl font-semibold text-white">
              24/7
            </div>
            <p className="text-sm text-[#A6BFAB] mt-1">
              Estamos disponibles todos los días del año, sin excepciones.
            </p>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row gap-4 items-center justify-between">
        <p className="text-xs text-[#A6BFAB]">
          © {new Date().getFullYear()} Royal Pets Veterinaria. Todos los
          derechos reservados.
        </p>
        <p className="text-xs text-[#A6BFAB]">
          Hecho con <span className="text-[#F28C8C]">♥</span> para nuestras
          mascotas.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
